import {
  CheckCircleIcon,
  ExclamationCircleIcon,
  FireIcon,
} from '@heroicons/react/20/solid';

import { CalendarWeekTotals } from '../api/types';

// Week-level summary pills: Critical (red), At risk (yellow), Filled (green).
// Counts come live from the calendar_week totals across the visible range.

type Props = { totals: CalendarWeekTotals };

const SummaryPills = ({ totals }: Props) => (
  <div className="dashv2-summary-pills">
    <span className="dashv2-summary-pill is-critical">
      <FireIcon />
      {totals.critical} Critical
    </span>
    <span className="dashv2-summary-pill is-atrisk">
      <ExclamationCircleIcon />
      {totals.at_risk} at risk
    </span>
    <span className="dashv2-summary-pill is-filled">
      <CheckCircleIcon />
      {totals.filled} Filled
    </span>
  </div>
);

export default SummaryPills;
